import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../../../../CloudStorage/LoadCSSforfirstTime";
import LogtimeForm from "./JobChilds/LogtimeForm";
import JobPendingSheetLists from "./JobChilds/JobPendingSheetLists";
import JobArchivedSheetLists from "./JobChilds/JobArchivedSheetLists";
import { useDispatch } from "react-redux";
import {
  AproveJobtime,
  CompletetheJob,
} from "../../../../../../../redux/job/action";
import { formatNumberWithCommas, getJobPriceWithLabel } from "../../../../../../Common/AllDateTimeReleventFormate";
import ModelJobConform from "./JobChilds/ModelJobConform";
import ModelExtraEscrow from "./JobChilds/ModelExtraEscrow";
import { Modal } from "reactstrap";
import { useRouteBaseStateContext } from "../../../../../../../Context/RouteBaseStateContext";

export default function MineActiveTimesheet({ posts, proposalmilestones }) {
  const { setMyorderActivejobsroute } = useRouteBaseStateContext();

  const [timedata, setTimeData] = useState("");
  const [loading, setLoading] = useState(false);
  const [review, setReview] = useState(false);
  const [activeTab, setActiveTab] = useState("pending");

  const dispatch = useDispatch();
  const [show, setshow] = useState(false);
  const [extraModal, setExtraModal] = useState(false);
  const [extraData, setExtraData] = useState(null);
  const path = "Assets/scss/dashboard.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const data = [
    ...(proposalmilestones?.job_time_thisweek || []),
    ...(proposalmilestones?.job_time_pending || [])
  ];
  function getCommaSeparatedJobTimeIds(data) {
    const jobTimeIds = data.flatMap((item) =>
      item.job_time.filter((job) => job.status == "0").map((job) => job.id),
    );
    return jobTimeIds.join(",");
  }

  const allstatuszerojobids = getCommaSeparatedJobTimeIds(data) || "";

  const aprroveallstatuszeroJobTimes = () => {
    const data = {
      type: "1",
      job_time_id: allstatuszerojobids,
      status: "1",
      posts_id: posts?.id,
    };
    dispatch(AproveJobtime(data, setLoading, (res) => {
      setExtraData(res);
      setExtraModal(true);
    }));
  };
  const completeJobTimes = () => {
    const data = {
      type: "3",
      id: proposalmilestones?.id,
      status: "31",
      posts_id: posts?.id,
    };
    dispatch(CompletetheJob(data, setLoading));
    setReview(false);
    setMyorderActivejobsroute("JobOverview");
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    // setMyorderActivejobsroute(tab);
  };

  console.log(posts?.status, 'posts?.statusposts?.statusposts?.status');


  return (
    <div className="timesheet">
      {posts?.is_mine == 1 ? (
        <>
          <h6>Timesheet</h6>
          <div className="row active-row">
            <div className="col-md-4 signup-back">
              <div className="signup-sec">
                <p>Total Logged hour</p>
                <h4>{proposalmilestones?.logged_hours} hrs</h4>
              </div>
            </div>
            <div className="col-md-4 signup-back">
              <div className="signup-sec">
                <p>{posts?.hiring_type == 4 ? "Logged this month" : "Logged this week"}</p>
                <h4>{proposalmilestones?.logged_thisweek_hours} hrs</h4>
              </div>
            </div>
            <div className="col-md-4 signup-back">
              <div className="signup-sec">
                <p>
                  {posts?.hiring_type == 4 ? "Total Cost this month :" : "Total Cost this week :"}
                  {getJobPriceWithLabel(proposalmilestones?.price, posts?.hiring_type)}
                </p>
                <h4>
                  $
                  {formatNumberWithCommas(proposalmilestones?.payment_thisweek)}
                </h4>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>{
          (posts?.status == 24 || posts?.status == 23) ? <></> :
            <div className="logged-time">
              <h5>
                Total Logged time :
                <span>{proposalmilestones?.logged_thisweek_hours} hrs</span>
              </h5>
              <LogtimeForm
                timedata={timedata}
                setTimeData={setTimeData}
                proposalmilestones={proposalmilestones}
                posts={posts}
              />
            </div>
        }
        </>
      )}

      <div className="tab-sec">
        <div className="timesheet-tab">
          <ul className="nav nav-tabs">
            <li className="nav-item" >
              <a data-toggle="tab"
                className={`nav-link ${activeTab == "pending" ? "active" : ""}`}
                onClick={() => handleTabClick("pending")}>
                Pending Sheets
              </a>
            </li>
            <li className="nav-item">
              <a data-toggle="tab" className={`nav-link ${activeTab == "archived" ? "active" : ""}`}
                onClick={() => handleTabClick("archived")}>
                Archived
              </a>
            </li>
          </ul>
          {posts?.is_mine == 1 && (
            <>
              {allstatuszerojobids != "" ? (
                <button
                  onClick={() => aprroveallstatuszeroJobTimes()}
                  className="buttons background-button"
                >
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/approve.svg`}
                    alt=""
                  />
                  Approve all
                </button>
              ) : (
                ""
              )}

              {(posts?.status == 22 || posts?.is_mine == 1) ? (
                <button
                  onClick={() => {
                    setReview(true);
                  }}
                  className="buttons background-button"
                >
                  Complete Job
                </button>
              ) : ""}
            </>
          )}
        </div>

        <div className="tab-content">
          <div className={`tab-pane ${activeTab == "pending" ? "active" : ""}`} id="pending">
            <JobPendingSheetLists
              proposalmilestones={proposalmilestones}
              posts={posts}
              setTimeData={setTimeData}
              setExtraData={setExtraData}
              setExtraModal={setExtraModal}
            />
          </div>
          <div className={`tab-pane ${activeTab == "archived" ? "active" : ""}`} id="archived">
            <JobArchivedSheetLists
              proposalmilestones={proposalmilestones}
              posts={posts}
              setTimeData={setTimeData}
              setExtraData={setExtraData}
              setExtraModal={setExtraModal}
            />
          </div>
        </div>
      </div>
      <Modal
        size="xl"
        className="popupmodal rent-modal"
        isOpen={review}
        toggle={() => setReview((state) => !state)}
      >
        <ModelJobConform
          completeJobTimes={completeJobTimes}
          setReview={setReview}
          proposalmilestones={proposalmilestones}
        />
      </Modal>

      <Modal
        size="xl"
        className="popupmodal rent-modal rent-1"
        
        isOpen={extraModal}
        toggle={() => setExtraModal((state) => !state)}
      >
        <ModelExtraEscrow
          setExtraModal={setExtraModal}
          extraData={extraData}
          proposalmilestones={proposalmilestones}
        />
      </Modal>
    </div>
  );
}
